export default "__VITE_ASSET__5xEsugC7__"